/**
 * Full-screen recovery page shown when the backend is unavailable (HTTP 503 —
 * the API started without a reachable database, "degraded mode"). Reached via
 * the /service-unavailable route, triggered from apiService on any 503.
 *
 * Copied from SnagScreen on purpose: same intentionally zero-dependency,
 * inline-styled shell (no Ionic, no theme store, no Tailwind reliance) so it
 * renders reliably regardless of app state. Only the copy differs. Colors
 * (#8f4420 brand primary, #B23A2E brand danger) and fonts Open Sans /
 * Montserrat are hand-copied from src/theme/variables.scss — keep in sync
 * with SnagScreen if tokens change.
 */
export const ServiceUnavailableScreen: React.FC = () => {
  const handleReload = () => {
    // Full navigation to "/", NOT reload(): reload() re-lands here at
    // /service-unavailable and the user is stuck once the BE recovers.
    // assign('/') is a full-page nav — resets module-level state (the
    // apiService serviceUnavailableActive latch) AND puts the user on the
    // app root so a healthy BE takes them straight into the normal flow.
    window.location.assign('/');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        color: '#1a1a1a',
        fontFamily:
          '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        textAlign: 'center',
      }}
    >
      <img
        src="/images/HomePlatedTM.svg"
        alt="Homeplated"
        style={{ width: '180px', maxWidth: '60%', height: 'auto', marginBottom: '32px' }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).src = '/images/HomePlatedTM.png';
        }}
      />

      <h1
        style={{
          fontFamily:
            '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          fontSize: '28px',
          fontWeight: 700,
          margin: '0 0 12px 0',
          color: '#B23A2E',
        }}
      >
        Temporarily Unavailable
      </h1>

      <p
        style={{
          fontSize: '15px',
          lineHeight: 1.5,
          maxWidth: '360px',
          margin: '0 0 32px 0',
          color: '#555',
        }}
      >
        HomePlated is temporarily unavailable. Please try again later.
      </p>

      <button
        type="button"
        onClick={handleReload}
        style={{
          appearance: 'none',
          border: 'none',
          backgroundColor: '#8f4420',
          color: '#ffffff',
          fontFamily: 'inherit',
          fontSize: '16px',
          fontWeight: 600,
          padding: '14px 32px',
          borderRadius: '999px',
          cursor: 'pointer',
          minWidth: '200px',
        }}
      >
        Try again
      </button>
    </div>
  );
};
